import httpClient from '@/services/httpClient'
import {
  AxiosEmailRequestAuthInterface,
  AxiosEmailRequestSignUpInterface,
  AxiosRequestResetPasswordInterface,
  AxiosResponseAuthInterface,
} from '@/types/types'
import {AxiosResponse} from 'axios'

const AuthService = {
  auth: (
    data: AxiosEmailRequestAuthInterface
  ): Promise<AxiosResponse<AxiosResponseAuthInterface>> =>
    httpClient.post('/auth/sign-in', data),
  signUp: (
    data: AxiosEmailRequestSignUpInterface
  ): Promise<AxiosResponse<AxiosResponseAuthInterface>> =>
    httpClient.post('/auth/sign-up', data),
  refresh: (
    refresh: string
  ): Promise<AxiosResponse<AxiosResponseAuthInterface>> =>
    httpClient.post('/auth/refresh/', {refresh}),
  verifyEmail: (data: {
    email: string
    code?: string
  }): Promise<AxiosResponse<any>> =>
    httpClient.post('/auth/verify-email', data),
  forgotPassword: (data: {
    email: string
  }): Promise<
    AxiosResponse<{
      expiration_at: string
    }>
  > => httpClient.post('/auth/forgot-password/', data),
  resetPassword: (
    data: AxiosRequestResetPasswordInterface
  ): Promise<
    AxiosResponse<{
      expiration_at: string
    }>
  > => httpClient.post('/auth/reset-password/', data),
}

export default AuthService
